<template>
  <div class="industrial-park-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/industrialPark/banner.jpg"
      />
    </div>
    <p class="section-title-line">
      <span>代表项目展示</span>
    </p>
    <div
      class="section-container intro-box-content"
      style="margin-bottom: 80px"
    >
      <p>琳琅满目的商品，南来北往的人流，商机在这里孕育，财富在这里汇聚。</p>
      <p>新希望商业综合体，汇聚世界机遇，掌控财富脉搏。</p>
    </div>
    <div class="section-container">
      <el-row :gutter="20">
        <el-col
          :span="12"
          v-for="(item, index) in list"
          :key="item.name + index"
          class="wow animate__slideInUp"
          data-wow-duration="500ms"
        >
          <div class="top-box">
            <img :src="item.image" alt="" />
          </div>
          <div class="bottom-box">
            <p class="name">{{ item.name }}</p>
            <p>项目概况</p>
            <div class="desc">
              <p v-for="(ele, i) in item.desc || []" :key="i" v-html="ele"></p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "IndustrialParkPage",
  data() {
    return {
      list: [
        {
          name: "半岛科技园",
          desc: [
            "项目位于上海市浦东新区中东部，国家级高科技产业园区张江高科技总部核心地带，科研教育规划区范围内。项目总占地面积约为4.3万m²,总建筑面积约为3.9万m²，于2007年竣工投入运营。",
            "项目三面环水，高科中路、达尔文路、白莲泾、吕家浜两路两河围成一个独立的半岛地形，楼借水势，取名“半岛科技园”。定位总部基地研发办公区，19栋5~6层 1300 - 2400m²的独立办公楼，突出总部办公楼气质。以园林式办公环境，吸引了诸多世界500强企业入驻，平均出租率约95%。根据2017年的统计，目前在张江科技园区办公人员已达16万人。",
          ],
          image: require('../../../assets/images/industrialPark/proj1.jpg')
        },
        {
          name: "中澳现代产业园",
          desc: [
            "“中澳现代产业园（舟山）”项目，占地11000亩，拟投资不低于100亿元人民币。该项目是落实习总书记2014年访问澳大利亚成果，推进落实中澳自贸协定和《中澳企业间农业与食品安全百年合作计划》（ASA100）的重要载体，对促进中澳两国贸易往来和友好关系具有十分重要的意义。",
            "中澳现代产业园以牛肉精深加工、高端食品加工产业和文化旅游产业为三大主导产业重点，着力于进口澳大利亚活牛及其下游延伸食品产业，建立综合贸易平台，配套引进跨境电商和建设澳洲风情小镇，形成四大功能区域，同时整合科研、教育、海洋等新兴产业协同发展，构建3+5+X的全新体系。",
          ],
          image: require('../../../assets/images/industrialPark/proj2.jpg')
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    })
  }
};
</script>
<style lang="scss" scoped>
.industrial-park-container {
  .top-box {
    overflow: hidden;
    width: 100%;
    > img {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }

  .bottom-box {
    height: 379px;
    overflow: hidden;
    padding: 30px;
    background-color: #ecedee;
    box-sizing: border-box;
    > p:nth-child(2) {
      margin-top: 20px;
      line-height: 40px;
      font-size: 14px;
    }
  }

  .name {
    text-align: justify;
    font-size: 28px;
    line-height: 40px;
    color: #008048;
  }

  .desc {
    > p {
      margin-bottom: 12px;
      line-height: 24px;
      font-size: 13px;
      text-align: justify;
      word-break: break-all;
      color: #565c61;
    }
  }
}
</style>
